import React  from "react";
import { useHistory } from 'react-router-dom';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";

// @material-ui/icons
import PersonIcon from '@material-ui/icons/Person';
import LockIcon from '@material-ui/icons/Lock';
import AssignmentIcon from '@material-ui/icons/AssignmentInd';
import NameIcon from '@material-ui/icons/HowToReg';

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";

import SimpleError from "views/component/SimpleError.js";
import SignUpConfirm from "views/component/SignUpConfirm.js";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

const useStyles = makeStyles(styles);

export default function SignUp() {
  const history = useHistory();

  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  const [userId, setIdState] = React.useState("");
  const [password, setPasswordState] = React.useState("");
  const [userName, setUserNameState] = React.useState("");
  const [userNumber, setUserNumberState] = React.useState("");

  const [errorShow, setErrorShow] = React.useState(false);
  const [confirmShow, setConfirmShow] = React.useState(false);

  const verifyLength = (value, length) => {
    if (value.length >= length) {
      return true;
    }
    return false;
  };

  const signUpButtonClick = function () {
    if(userNumber === "") {
      setUserNumberState("error");
    }
    if(userName === "") {
      setUserNameState("error");
    }
    if(userId === "") {
        setIdState("error");
    }
    if(password === "") {
        setPasswordState("error");
    }

    if(userId !== "error" && userId !== "" && password !== "error" && password !== ""
        && userName !== "error" && userName !== "" && userNumber !== "error" && userNumber !== "") {
      setErrorShow(false);
      setConfirmShow(true);
    } else {
      setErrorShow(true);
    }
  };

  const enterKeyPress = function (event) {
    if(event.key === "Enter") {
        signUpButtonClick();
    }
  };

  const onConfirmFail = function () {
    setErrorShow(false);
  }

  const onComfirmSuccess = function () {
    setConfirmShow(false);
    /*
    axios.post('data/user/login',
      {
        'userNumber': userNumber,
        'userName': userName,
        'userId': userId,
        'password': password
      }
      ).then(response => {
        history.push('/user/login');
    });*/
    history.push('/user/login');
  }

  React.useEffect(() => {
    let id = setTimeout(function() {
      setCardAnimation("");
    }, 700);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.clearTimeout(id);
    };
  });

  const classes = useStyles();
  return (
    <div className={classes.container}>
        <SimpleError show={errorShow} title="입력 정보를 확인해주세요" onConfirm={onConfirmFail}/>
        <SignUpConfirm show={confirmShow} title="사용자 등록 완료" onConfirm={onComfirmSuccess}/>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form>
              <Card login className={classes[cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="success"
                >
                  <h4 className={classes.cardTitle}>FACTORY DOCTOR</h4>
                </CardHeader>
                <CardBody>
                    <CustomInput
                        error={userNumber === "error"}
                        labelText="User Number *"
                        id="userNumber"
                        underlineColor="success"
                        onKeyPress={enterKeyPress}
                        formControlProps={{
                        fullWidth: true
                        }}
                        inputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                            <AssignmentIcon className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                        ),
                        onChange: event => {
                            if(verifyLength(event.target.value, 1)) {
                            setUserNumberState(event.target.value);
                            } else {
                                setUserNumberState("error");
                            }
                        },
                        type: "text",
                        autoComplete: "off"
                        }}
                    />
                    <CustomInput
                        error={userName === "error"}
                        labelText="Name *"
                        id="userName"
                        underlineColor="success"
                        onKeyPress={enterKeyPress}
                        formControlProps={{
                        fullWidth: true
                        }}
                        inputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                            <NameIcon className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                        ),
                        onChange: event => {
                            if(verifyLength(event.target.value, 1)) {
                                setUserNameState(event.target.value);
                            } else {
                                setUserNameState("error");
                            }
                        },
                        type: "text",
                        autoComplete: "off"
                        }}                          
                  />
                  <CustomInput
                    error={userId === "error"}
                    labelText="id *"
                    id="userId"
                    underlineColor="success"
                    onKeyPress={enterKeyPress}
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <PersonIcon className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      onChange: event => {
                        if(verifyLength(event.target.value, 1)) {
                          setIdState(event.target.value);
                        } else {
                          setIdState("error");
                        }
                      },
                      type: "text",
                      autoComplete: "off"
                    }}
                  />
                  <CustomInput
                    error={password === "error"}
                    labelText="Password *"
                    id="password"
                    underlineColor="success"
                    onKeyPress={enterKeyPress}
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <LockIcon className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      onChange: event => {
                        if(verifyLength(event.target.value, 1)) {
                          setPasswordState(event.target.value);
                        } else {
                          setPasswordState("error");
                        }
                      },
                      type: "password",
                      autoComplete: "off"
                    }}
                  />
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                <Button color="success" size="lg" onClick={signUpButtonClick} className={classes.registerButton}>
                    sign up
                  </Button>
                </CardFooter>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
    </div>
  );
}
